<template>
  <div class="page" id="contactDebtorList">



    <div class="page-content">
    <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Creditors list"></page-nav-bar>
<!--
        <div class="contactButtonContainer">
          <f7-grid no-gutter>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' :class="getColor" v-if="currentRole === 'simple'" tab-link=".contactTab1" @click="changeCurrentRole('simple')" active>Beneficiaries</f7-link>
              <f7-link class='pilotageLink' v-else tab-link=".contactTab1" @click="changeCurrentRole('simple')" active>Contact List</f7-link>
            </f7-col>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' :class="getColor" v-if="currentRole === 'group'" tab-link=".contactTab2" @click="changeCurrentRole('group')">Groups</f7-link>
              <f7-link class='pilotageLink' v-else tab-link=".contactTab2" @click="changeCurrentRole('group')">Group List</f7-link>
            </f7-col>
          </f7-grid>
        </div>
-->
        <f7-tabs>
          <f7-tab class="requestContactTab1" active>
            <f7-searchbar class="webdatalist"
              cancel-link="Cancel"
              search-list="#contact-debtors-list"
              placeholder="Search in Creditors">
            </f7-searchbar>
            <div class="webdatalist">
              <f7-list id="contact-debtors-list" contacts>
                <f7-list-group v-for="(group, key) in this.contactSelectionList" :key="key">
                  <f7-list-item :title="key" group-title></f7-list-item>
                  <li v-for="contact in group" v-on:change="changeItem()">
                    <label class="label-checkbox item-content boxRequest">
                      <input class="inputContact" type="checkbox" name="contactDebtorCheckbox" :value="contact.id" v-model="contactDebtors">
                      <div class="item-media">
                        <i class="icon icon-form-checkbox"></i>
                      </div>
                      <div class="item-inner">
                        <div class="item-title">{{contact.label}}</div>
                      </div>
                    </label>
                  </li>
                </f7-list-group>
              </f7-list>
            </div>
          </f7-tab>
          <f7-tab class="requestContactTab2">
            <f7-searchbar class="webdatalist"
              cancel-link="Cancel"
              search-list="#contact-debtors-list"
              placeholder="Search in Groups">
            </f7-searchbar>
            <f7-list>
              <li v-for="(contactGroup, index) in contactGroups" v-on:change="changeGroupItem()">
                <label class="label-checkbox item-content">
                  <input type="checkbox" name="contactGroupCheckbox" :value="contactGroup.id" v-model="contactGroupsSelected">
                  <div class="item-media">
                    <i class="icon icon-form-checkbox"></i>
                  </div>
                  <div class="item-inner">
                    <div class="item-title">{{ contactGroup.label }}</div>
                  </div>
                </label>
              </li>
            </f7-list>
          </f7-tab>
        </f7-tabs>
        <div class="webdatalist row" :class="colorBottomButton">
          <div class="col-md-3">
              <f7-button round title="" class="orangeConfirmationButton button-inner-color" @click="cancel">
                <f7-link class=""> Cancel</f7-link>
              </f7-button>
          </div>
          <div class="col-md-3 offset-md-3">
            <f7-button round title="Add Contact" class="orangeConfirmationButton button-inner-color" @click="goBack">
              <f7-link class="">Add contact</f7-link>
            </f7-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  name: 'contactDebtorList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      contactDebtors: [],
      contactSelectionList: [],
      currentRole: '',
      contactGroups: [],
      contactGroupsSelected: [],
      contactGroupsSelectedOld: []
    }
  },
  mounted () {
    let that = this
    that.contactDebtors = this.$engine.services.payments.contactDebtorList
    var contactList = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!contactList.hasOwnProperty(firstLetter)) {
        contactList[firstLetter] = []
      }
      contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id, typeContact: this.$engine.contacts.get(j).typeContact})
      contactList[firstLetter].sort()
    }
    this.contactSelectionList = this.orderKeys(contactList)
    this.currentRole = 'simple'
    // TODO
    that.contactGroups = this.$engine.contacts.getContactGroup()
    this.contactGroupsSelected = this.$engine.services.payments.contactGroupsSelected
    this.contactGroupsSelectedOld = this.$engine.services.payments.contactGroupsSelected
  },
  created () {
  },
  computed: {
    getColor: function () {
      return {
        'tabActive_DD': this.$engine.user.currentService.name === 'Direct Debit',
        'tabActive_P': this.$engine.user.currentService.name === 'Payments',
        'tabActive': this.$engine.user.currentService.name === 'Direct Payments'
      }
    }
  },
  methods: {
    removeDebtor (key) {
      this.$engine.services.payments.debtorList.splice(key, 1)
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
      }
      if (this.currentRole === 'simple') {
        this.Dom7('.requestContactTab2').removeClass('active')
        this.Dom7('.requestContactTab1').addClass('active')
      } else if (this.currentRole === 'group') {
        this.Dom7('.requestContactTab1').removeClass('active')
        this.Dom7('.requestContactTab2').addClass('active')
      }
    },
    changeItem () {
      let that = this
      that.contactDebtors = []
      this.Dom7('input[name=contactDebtorCheckbox]:checked').each(function () {
        that.contactDebtors.push(that.Dom7(this).val())
      })
      this.$engine.services.payments.contactDebtorList = that.contactDebtors
    },
    changeGroupItem () {
      let that = this
      // Get checked contact group
      that.contactGroupsSelected = []
      this.Dom7('input[name=contactGroupCheckbox]:checked').each(function () {
        that.contactGroupsSelected.push(that.Dom7(this).val())
      })
      // Get unchecked contact group
      let contactGroupUnchecked = []
      for (let k = 0; k < that.contactGroupsSelectedOld.length; k++) {
        if (!that.contactGroupsSelected.includes(that.contactGroupsSelectedOld[k])) {
          contactGroupUnchecked.push(that.contactGroupsSelectedOld[k])
        }
      }

      // Delete contact from debtor list if contact is in un checked contact group
      for (let l = 0; l < that.contactGroups.length; l++) {
        if (contactGroupUnchecked.includes(that.contactGroups[l].id)) {
          for (let m = 0; m < that.contactGroups[l].contacts.length; m++) {
            var index = that.contactDebtors.indexOf(that.contactGroups[l].contacts[m])
            if (index > -1) {
              that.contactDebtors.splice(index, 1)
            }
          }
        }
      }
      // Add new contacts
      for (let i = 0; i < that.contactGroups.length; i++) {
        if (that.contactGroupsSelected.includes(that.contactGroups[i].id)) {
          for (let j = 0; j < that.contactGroups[i].contacts.length; j++) {
            if (!that.contactDebtors.includes(that.contactGroups[i].contacts[j])) {
              that.contactDebtors.push(that.contactGroups[i].contacts[j])
            }
          }
        }
      }
      that.contactGroupsSelectedOld = that.contactGroupsSelected
      this.$engine.services.payments.contactGroupsSelected = that.contactGroupsSelected
      this.$engine.services.payments.contactDebtorList = that.contactDebtors
    },
    goBack () {
      this.$bus.emit('refresh-debtor-contact-list', this.contactDebtors)
      this.$f7.mainView.router.back()
    },
    cancel () {
      // this.$bus.emit('refresh-debtor-contact-list', this.contactDebtors)
      this.$f7.mainView.router.back()
    }
  }
}
</script>

<style scoped>
@media (min-width: 993px) {
  .search {
    margin-top: 80px;
  }
  .page-content {
    padding-top: 123px;
  }
}
@media (max-width: 992px) {
  .search {
    margin-top: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// CMContactDebtorList.vue?2f57351b